import PageSceneBase from './PageSceneBase';
import PageExerciseScene from './PageExerciseScene';
import { ITeamModes, iteamWorkingModeInstance } from '../datamodel/datamodel';


class PageScene extends PageSceneBase {

    constructor(param) {
        super({key: 'PageScene', config: param.config});
        super.closeDrawingThicknessMenuCallback = param.setCloseDrawingThicknessMenuCallback;
        this.closeDrawingThicknessMenuCallback = param.setCloseDrawingThicknessMenuCallback; // used only to pass this function to PageExerciseScene



        this.pageDM = null;
        this.currentShowingExerciseSequence = -1; // none
        this.pageExerciseScene = null;

        this.setExerciseCloseCallback = param.setExerciseCloseCallback;
        this.setExerciseSceneHandler = param.setExerciseSceneHandler;
        this.setExerciseVideoDMHandler = param.setExerciseVideoDMHandler;
        this.setExerciseAudioDMHandler = param.setExerciseAudioDMHandler;
        this.setResizeEnabled = param.setResizeEnabled;
        this.setLinkUrlCallBack = param.setLinkUrlCallBack;

        this.tween1 = null;
        this.tween2 = null;

        this.removePage = this.removePage.bind(this);
    }

    preload() {
        super.preload();
        console.log('PageScene preload');
        this.load.off('filecomplete', this.fileLoadComplete, this);
        this.load.on('filecomplete', this.fileLoadComplete, this);
    }

    create() {
        super.create();   
    }


    update() {
        super.update();
    }


    loadPageDM(pageDM) {
        // first clear old stuff.
        this.removePage();
        if (this.textures.exists('page')) {
            this.textures.remove('page');
        }

        // trigger load new stuff
        this.pageDM = pageDM;
        this.load.image('page', `${this.pageDM.basePath}/${this.pageDM.pageUrl}`);
        this.load.start();
        console.log('PageScene loadPageDM() is called');
    }


    removePage() {
        this.removeInteractionButtons(); // first remove current interactive buttons from page
        if (this.pageImage !== null) {  // then remove page itself
            this.pageImage.off('pointerdown');
            //this.pageImage.destroy();
            //this.pageImage = null;
        }
    }

    addPage() {
        if (!this.textures.exists('page')) {
            return;
        }
        this.pageImage = this.add.image(0, 0, 'page').setOrigin(0);
        this.contentContainer.add(this.pageImage);
    
        this.createInteractionButtons();

        this.prepareDrawingBrush();
        this.addDrawingCanvases();

        this.setResizeEnabled(true);


        let displayWidthHeightRatio = this.config.width / this.config.height;
        let pageWidthHeightRatio = this.pageImage.width / this.pageImage.height;
        if (displayWidthHeightRatio > pageWidthHeightRatio) {
            this.zoomFitHeight();
        } else {
            this.zoomFitWidth();
        }
    }
    

    removeInteractionButtons() {
 
        if (this.pageDM === null) {
            return;
        }

        if (this.pageDM.exercises !== null) {
            // unload exercise handles
            this.pageDM.exercises.map(exercise => {
                let exerciseDM = exercise;
                if (exerciseDM.handle === null) {
                    return exercise;
                }

                let exerciseHandleDM = exerciseDM.handle;
                if (exerciseHandleDM.visualButton !== null) {
                    exerciseHandleDM.visualButton.destroy();
                    exerciseHandleDM.visualButton = null;
                }
                
                return exercise;
            });
        }

        if (this.pageDM.links !== null) {
            // unload link handles
            this.pageDM.links.map(link => {
                let linkDM = link;
                if (linkDM.handle === null) {
                    return link;
                }

                let linkHandleDM = linkDM.handle;
                if (linkHandleDM.visualButton !== null) {
                    linkHandleDM.visualButton.destroy();
                    linkHandleDM.visualButton = null;
                }
                
                return link;
            });
        }

    }


    createInteractionButtons() {
 
        if (this.pageDM === null) {
            return;
        }

        if (this.pageDM.exercises === null) {
            return;
        }

        // load exercise handles
        this.pageDM.exercises.map((exerciseDM, index) => {

            if (exerciseDM.handle === null) {
                return exerciseDM;
            }

            let exerciseHandleDM = exerciseDM.handle;
            let rectangle = this.add.rectangle(exerciseHandleDM.x, exerciseHandleDM.y, 
                                exerciseHandleDM.w, exerciseHandleDM.h, 0xff0000, 0.25).setOrigin(0);
            rectangle.setStrokeStyle(2, 0x8855ff);
            rectangle.setInteractive();
            rectangle.on('pointerdown', (pointer, localX, localY, event) => {
                this.exerciseHandleOnPointerdown(exerciseDM, index);
            }, this);

            this.contentContainer.add(rectangle);
            let tween = this.tweens.add({
                targets: rectangle,
                alpha: 0.1,
                yoyo: true,
                repeat: -1,
                ease: 'easeInQuint'
            });

            rectangle.setDataEnabled(true);
            rectangle.data.set('tween', tween);

            exerciseHandleDM.visualButton = rectangle;
            return exerciseDM;
        });


        // load links handles
        this.pageDM.links.map((linkDM, index) => {

            if (linkDM.handle === null) {
                return linkDM;
            }

            let linkHandleDM = linkDM.handle;
            let rectangle = this.add.rectangle(linkHandleDM.x, linkHandleDM.y, 
                                linkHandleDM.w, linkHandleDM.h, 0x0000ff, 0.25).setOrigin(0);
            rectangle.setStrokeStyle(2, 0xff0000, 0.25);
            rectangle.setInteractive();
            rectangle.on('pointerdown', (pointer, localX, localY, event) => {
                this.linkHandleOnPointerdown(linkDM, index);
            }, this);

            this.contentContainer.add(rectangle);
            let tween = this.tweens.add({
                targets: rectangle,
                alpha: 0.1,
                yoyo: true,
                repeat: -1,
                ease: 'easeInQuint'
            });

            rectangle.setDataEnabled(true);
            rectangle.data.set('tween', tween);

            linkHandleDM.visualButton = rectangle;
            return linkHandleDM;
        });
    }

    linkHandleOnPointerdown(linkDM, linkSequence) {
        console.log(linkDM);


        this.setLinkUrlCallBack(linkDM.url);

    }


    exerciseHandleOnPointerdown(exerciseDM, exerciseSequence) {
        
        if (iteamWorkingModeInstance.getMode() !== ITeamModes.interaction) {
            return;
        }


        if (this.textures.exists('exerciseCanvas')) {
            this.textures.remove('exerciseCanvas');
        }


        // to combine each zoomInit horizontally we must sum the widths and choos the highest h
        let calculatedCanvasWidth = 0;
        let calculatedCanvasHeight = 0;
        exerciseDM.zoomInits.forEach(zoomInit => {
            calculatedCanvasWidth +=  zoomInit.w;
            if (calculatedCanvasHeight < zoomInit.h) {
                calculatedCanvasHeight = zoomInit.h;
            }
        });
        

        let canvas = document.createElement('canvas');
        canvas.width = calculatedCanvasWidth;
        canvas.height = calculatedCanvasHeight;
        

        let ctx = canvas.getContext('2d');


        let sourceImage = this.textures.get('page').getSourceImage();


        // combine each zoomInit horizontally, aligned top
        let newX = 0;
        exerciseDM.zoomInits.forEach(zoomInit => {
            ctx.drawImage(sourceImage,
                zoomInit.x,
                zoomInit.y,
                zoomInit.w, 
                zoomInit.h,
                newX, 0,
                zoomInit.w,
                zoomInit.h);

            newX += zoomInit.w;
        });


        this.textures.addCanvas('exerciseCanvas', canvas);

        this.pageExerciseScene = new PageExerciseScene({ config: this.config, 
                                                        exerciseDM: exerciseDM,
                                                        setResizeEnabled: this.setResizeEnabled,
                                                        setCloseDrawingThicknessMenuCallback: this.closeDrawingThicknessMenuCallback,
                                                        resizeHandler: () => {}
                                                     });

        this.game.scene.add('PageExerciseScene', this.pageExerciseScene);
        this.currentShowingExerciseSequence = exerciseSequence;
        this.scene.launch('PageExerciseScene');
        this.scene.pause('PageScene');
        this.scene.setVisible(false);

        this.setExerciseCloseCallback(() => this.pageExerciseScene.returnToPageButtonClickHandler());

        this.setExerciseSceneHandler(this.pageExerciseScene);
        if (exerciseDM.audios.length > 0) {
            let audioDM = exerciseDM.audios[0];
            this.setExerciseAudioDMHandler(audioDM);
        } else {
            this.setExerciseAudioDMHandler(null);
        }

        if (exerciseDM.videos.length > 0) {
            let videoDM = exerciseDM.videos[0];
            this.setExerciseVideoDMHandler(videoDM);
        } else {
            this.setExerciseVideoDMHandler(null);
        }


    }


    nextExerciseClickHandler() {
        if (this.currentShowingExerciseSequence < 0) {
            return;
        }

        if (this.currentShowingExerciseSequence >= this.pageDM.exercises.length - 1) {
            // close current exercise and return to page display.
            if (this.pageExerciseScene !== null) {
                this.pageExerciseScene.returnToPageButtonClickHandler(); // close current exercise scene & return back to page scene
                return;
            }
        }

        let nextExerciseIndex = this.currentShowingExerciseSequence + 1;


        if (this.pageExerciseScene !== null) {
            // the following resets this.currentShowingExerciseSequence to -1 be carefull
            this.pageExerciseScene.returnToPageButtonClickHandler(); // close current exercise scene & return back to page scene
        }

        let exerciseDM = this.pageDM.exercises[nextExerciseIndex];

        this.exerciseHandleOnPointerdown(exerciseDM, nextExerciseIndex);
    }

    prevExerciseClickHandler() {
        if (this.currentShowingExerciseSequence < 0) {
            return;
        }

        if (this.currentShowingExerciseSequence === 0) {
             // close current exercise and return to page display.
             if (this.pageExerciseScene !== null) {
                this.pageExerciseScene.returnToPageButtonClickHandler(); // close current exercise scene & return back to page scene
                return;
            }           
        }

        let prevExerciseIndex = this.currentShowingExerciseSequence - 1;

        if (this.pageExerciseScene !== null) {
            // the following resets this.currentShowingExerciseSequence to -1 be carefull
            this.pageExerciseScene.returnToPageButtonClickHandler(); // close current exercise scene & return back to page scene
        }

        let exerciseDM = this.pageDM.exercises[prevExerciseIndex];

        this.exerciseHandleOnPointerdown(exerciseDM, prevExerciseIndex);
    }

    /*
     * fileLoadComplete - It is callback of loader set up at preload phase.
     *                    It is responsible of adding newly loaded page to the Scene aka Container. 
     */
    fileLoadComplete(key, type, data) {
        if (type === 'image' && key === 'page') {
            console.log('PageScene page fileLoadComplete');
            this.addPage();
        }
    }

}

export default PageScene;